<template>
  <div
    :class="{ 'z-toast__box-wrapper--is-open' : isOpen }"
    class="z-toast__box-wrapper"
  >
    <div
      :class="`z-toast__box--${type}`"
      class="z-toast__box z-toast__box-override"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <span class="z-toast__icon">
        <z-icon :icon="['fas', iconName]" size="medium" />
      </span>

      <p class="z-toast__text z-toast__test-override">
        {{ message }}
      </p>

      <button
        type="button"
        aria-label="Fechar"
        data-dismiss="z-toast"
        class="z-modal__close-button"
        title="Fechar"
        @click="close()"
      >
        <span class="z-toast__close-icon">
          <z-icon :icon="['fal', 'times']" size="medium" />
        </span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.z-toast__box-override {
  align-items: center;
  min-height: 70px;
}

.z-toast__test-override {
  font-size: rem(19)
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default',
      validator: (type) => [
        'default',
        'success',
        'danger',
        'warning',
      ].includes(type),
    },
    message: {
      type: String,
      required: true,
    },
    timeout: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      isOpen: true,
      iconsMap: {
        default: 'info-circle',
        success: 'check-circle',
        danger: 'times-circle',
        warning: 'exclamation-circle',
      },
    };
  },
  computed: {
    iconName() {
      return this.iconsMap[this.type];
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    if (this.timeout) {
      setTimeout(() => {
        this.close();
      }, this.timeout);
    }
  },
};
</script>
